<template>
  <el-container>
    <el-main style="padding: 0">
      <div>
        <view-table
            ref="viewTable"
            :filter="filter"
            :limits="limits"
            :columns-property="columnsProperty"
            module="basic"
            url="inspectionTemplates"
            @addOrEdit="addEditHandle"
            @select="selectHandle"
            @delete="deleteHandle"
            @reset="resetHandle">
          <template slot="adSearch">
            <el-form :inline="true" :model="filter" @submit.native.prevent @keyup.enter.native="loadData(1)">
              <el-form-item label="编号：">
                <el-input v-model.trim="filter.templateNo" placeholder="请输入" clearable/>
              </el-form-item>
              <el-form-item label="名称：">
                <el-input v-model.trim="filter.templateName" placeholder="请输入" clearable/>
              </el-form-item>
              <el-form-item label="类型：">
                <el-select v-model.trim="filter.templateType">
                  <el-option label="全部" :value="-1"/>
                  <el-option label="外购入库" :value="10"/>
                  <el-option label="成品入库" :value="20"/>
                  <el-option label="生产过程" :value="30"/>
                  <el-option label="成品出库" :value="40"/>
                  <el-option label="巡检" :value="50"/>
                </el-select>
              </el-form-item>
            </el-form>
          </template>
        </view-table>
        <!-- 编辑 -->
        <material-template-edit ref="templateEdit" @save-success="loadData"/>
      </div>
    </el-main>
  </el-container>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  import MaterialTemplateEdit from "./MaterialTemplateEdit";

  export default {
    name: "TemplateManagementList",
    components: {
      ViewTable,
      MaterialTemplateEdit,
    },
    data() {
      return {
        limits:{
          addAuth: this.$auth(434),
          editAuth: this.$auth(435),
          delAuth: this.$auth(436),
        },
        importLoading: false,
        mainBoxHeight: 0,
        data: [],
        filterText: "",
        filter: {
          templateNo: "",
          templateName: "",
          templateType:-1,
        },
        columnsProperty:[
          {
            key:"no",
            align:"center",
          },
          {
            key:"name",
            align:"center",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
        selection: [],
      };
    },

    methods: {
      addEditHandle(row) {
        this.$refs.templateEdit.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 删除(单删、多删)
      deleteHandle(row) {
        let ids = [];
        ids.push(row.employeeID);
        this.$http.delete("basic", "inspectionTemplates", row.pkId).then((res) => {
          if (res.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      // checkBox
      selectHandle(selection) {
        this.selection = selection;
        console.log(this.selection);
      },
      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
<style scoped>
</style>

<style>
</style>
